'use strict';

const { DEFAULT_COHORT } = require('./constants');

// Validate that app has the corect format because it is used to construct eid's
function validateApp(app = '') {
  // https://confluence.godaddy.com/display/CKPT/Event+Naming+and+Formats
  if (!app.match(/^[a-z0-9_-]+$/)) {
    throw new Error(`Parameter 'app' must match regex '/^[a-z0-9_-]+$/'`);
  }
}

function updateCohortAllocationsWithEid(cohortAllocations, app) {
  Object.keys(cohortAllocations).forEach(experimentId => {
    const cohort = cohortAllocations[experimentId].error ? 'error' : cohortAllocations[experimentId].cohortId;
    cohortAllocations[experimentId].eid =
      `hivemind.${app}.experiment.${experimentId}.${cohort}.impression`;
  });

  return cohortAllocations;
}

function generateDefaultAllocations(experiments) {
  return experiments.reduce((allocations, experiment) =>
    Object.assign(allocations, { [experiment]: { cohortId: DEFAULT_COHORT, data: {} } }),
  {});
}

function groupEligibleExperimentsById({ subject, experiments, experimentsMetadata }) {
  // Collect all experiments with no metadata as ineligible experiments
  const ineligibleExperiments = experiments.filter(experiment => !(experiment in experimentsMetadata));
  // Group experiments by ID. If subject does not contain that ID type, add to ineligibleExperiments
  const experimentsByIdType = Object.entries(experimentsMetadata).reduce((mapping, [experimentId, metadata]) => {
    if (!subject[metadata.subjectIdType]) {
      ineligibleExperiments.push(experimentId);
    } else {
      if (!mapping[metadata.subjectIdType]) mapping[metadata.subjectIdType] = [];
      mapping[metadata.subjectIdType].push(experimentId);
    }
    return mapping;
  }, {});
  return { experimentsByIdType, ineligibleExperiments };
}

module.exports = {
  validateApp,
  updateCohortAllocationsWithEid,
  generateDefaultAllocations,
  groupEligibleExperimentsById
};
